import { useEffect, useState } from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    FormControl,
    FormLabel,
    Spinner,
} from "@chakra-ui/react";
import { Tenant, User } from "@bluefalcon/users-management-client-fetch";
import { SearchableDropdown } from "../components/base/searchable-dropdown/searchable-dropdown.comp";
import { tenantsService, usersService } from "../services";

type GrantMembershipModalProps = {
    initialTenant?: Tenant;
    initialUser?: User;
    onGrant: (tenantId: string, userId: string) => void;
    isOpen: boolean;
    onClose: () => void;
    isLoading: boolean;
};

export const GrantMembershipModal = ({
    initialTenant,
    initialUser,
    onGrant,
    isOpen,
    onClose,
    isLoading,
}: GrantMembershipModalProps) => {
    const [selectedTenant, setSelectedTenant] = useState<Tenant>();
    const [selectedUser, setSelectedUser] = useState<User>();
    const [tenants, setTenants] = useState<Tenant[]>([]);
    const [users, setUsers] = useState<User[]>([]);

    const handleGrant = () => {
        console.log(selectedTenant, selectedUser)
        if (selectedTenant && selectedUser) {
            onGrant(selectedTenant.id, selectedUser.id);
        }
    };

    const getNameFromUser = (user: User) => {
        return `${user.firstName} ${user.lastName}`;
    };

    const onSelectTenant = (name?: string) => {
        setSelectedTenant(tenants.find((t) => t.name === name));
    };

    const onSelectUser = (name?: string) => {
        setSelectedUser(users.find((u) => getNameFromUser(u) === name));
    };

    const fetchTenants = async () => {
        const res = await tenantsService.searchTenants({});
        setTenants(res.results);
    };

    const fetchUsers = async () => {
        const res = await usersService.searchUsers({});
        setUsers(res.results);
    };

    useEffect(() => {
        if (isOpen) {
            if (!initialTenant) {
                fetchTenants();
            }
            if (!initialUser) {
                fetchUsers();
            }
        }
    }, [isOpen]);

    useEffect(() => {
        setSelectedTenant(initialTenant);
        setSelectedUser(initialUser);
    }, [initialTenant, initialUser]);

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            {!isLoading ? <ModalContent>
                <ModalHeader>Grant Role</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <FormControl isRequired>
                        <FormLabel>Tenant</FormLabel>
                        <SearchableDropdown
                            items={tenants.map((t) => t.name)}
                            placeholder="Tenant"
                            onSelect={(name) => onSelectTenant(name)}
                            isDisabled={!!initialTenant}
                            value={initialTenant?.name ?? selectedTenant?.name}
                            titleTag="Tenant"
                        />
                    </FormControl>
                    <FormControl isRequired>
                        <FormLabel>User</FormLabel>
                        <SearchableDropdown
                            items={users.map((t) => `${t.firstName} ${t.lastName}`)}
                            placeholder="User"
                            onSelect={(name) => onSelectUser(name)}
                            isDisabled={!!initialUser}
                            value={initialUser ? getNameFromUser(initialUser) : selectedUser ? getNameFromUser(selectedUser) : undefined}
                            titleTag="User"
                        />
                    </FormControl>
                </ModalBody>
                <ModalFooter>
                    <Button variant="ghost" onClick={onClose} mr={3}>Cancel</Button>
                    <Button colorScheme="primary" onClick={handleGrant}>Grant</Button>
                </ModalFooter>
            </ModalContent> : <Spinner />}
        </Modal>
    );
};
